<template>
    <div>
        <div class="container mb-4">
            <h1>Confirm your account</h1>
        </div>
        <div class="container" v-if="status == ''">
            <div class="col-md-8">
                <div class="alert alert-info">
                    <p class="mt-2">
                        <strong>Please wait, we're verifying your account.</strong>
                    </p>
                    <div class="spinner-container">
                        <div class="spinner"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container" v-if="status == 'success'">
            <div class="col-md-8">
                <div class="alert alert-success">
                    <p class="mt-2">
                        <strong>Success!</strong>
                    </p>
                    <p>Your account is confirmed.</p>
                    <p>
                        You can now
                        <router-link to="/">login</router-link>.
                    </p>
                </div>
            </div>
        </div>
        <div class="container" v-if="status == 'expired'">
            <div class="col-md-8">
                <div class="alert alert-danger">
                    <p class="mt-2">
                        <strong>Oops! That didn't work.</strong>
                    </p>
                    <p>
                        Your confirmation code expired. Please try
                        <router-link to="/create-account">creating an account</router-link>&nbsp;again.
                    </p>
                </div>
            </div>
        </div>
        <div class="container" v-if="status == 'fail'">
            <div class="col-md-8">
                <div class="alert alert-danger">
                    <p class="mt-2">
                        <strong>Oops! That didn't work.</strong>
                    </p>
                    <p>We seem to be having issues with this service. Please reach out to The Film Office for help.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "confirm-account",
    data() {
        return {
            status: ""
        };
    },
    computed: {
        stamp() {
            if (this.$route.query.stamp) {
                return encodeURI(this.$route.query.stamp).replace(
                    new RegExp(/%20/gi),
                    "+"
                );
            }
            return null;
        },
        token() {
            if (this.$route.query.token) {
                return encodeURI(this.$route.query.token).replace(
                    new RegExp(/%20/gi),
                    "+"
                );
            }
            return null;
        }
    },
    created() {
        const resetInfo = `?token=${this.token}&stamp=${this.stamp}`;

        this.$store.dispatch("AUTH_CONFIRM_NEW_USER", resetInfo).then(resp => {
            if (resp == "success") {
                this.status = "success";
            } else {
                this.status = "fail";
            }
        });
    }
};
</script>